import React, { Component, PropTypes } from 'react';
import { push, replace } from 'react-router-redux';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import isLoggedIn from '../utils/index';
import Autosuggest from 'react-autosuggest';
import { loadSearchSuggestions } from '../actions';


class SearchFrom extends Component {
  state = {
    query: ''
  };

  updateQuery = e => {
    this.setState({ query: e.target.value});
    e.preventDefault();
  };

  doSearch = e => {
    e.preventDefault();
    this.props.replace(`/search?q=${this.state.query}`);
  };

  renderSuggestion = (suggestion) => {
    return <span>{suggestion.name}</span>;
  }

  shouldRenderSuggestions = (value) => {
    if (value) {
      return value.trim().length > 2;
    }
    return false;
  };


  onSuggestionsFetchRequested = ({ value }) => {
    this.props.loadSearchSuggestions(value);
  }

  onSuggestionsClearRequested = () => {
  };

  getSuggestionValue = (suggestion) => {
    return suggestion.name;
  }

  onInputChange = (e, { newValue, method }) => {
    if (method === 'type') {
      this.setState({ query: newValue});
    }
  }

  onSuggestionSelected = (event, { suggestion, suggestionValue, sectionIndex, method }) => {
    event.preventDefault();
    if(suggestion.id == 0 ) {
      this.doSearch(event);
    } else {
      this.props.push(`/organizations/${suggestion.id}`);
    }
  }

  render() {
    let buttonText = 'Go';
    if(this.props.inFooter) {
      buttonText = <i className="fa fa-search"></i>;
    }

    let rightMargin = '0';
    if(isLoggedIn()) {
      rightMargin = '15rem';
    }

    let inputProps = {
      name: 'q',
      value: this.state.query,
      onChange: this.onInputChange,
      placeholder: 'Search...',
      autoComplete: 'off'
    };

    const suggestions = this.props.searchSuggestions.results;
    let finalSuggestions = suggestions.slice(0);
    if(finalSuggestions.length > 0) {
      finalSuggestions.unshift({
        name: 'show all listings',
        id: 0
      });
    }


    return (
      <div className="search-form-wrapper">
        <form onSubmit={this.doSearch} className="search-form">
          <Autosuggest suggestions={finalSuggestions}
                       inputProps={inputProps}
                       onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                       onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                       getSuggestionValue={this.getSuggestionValue}
                       focusInputOnSuggestionClick={false}
                       renderSuggestion={this.renderSuggestion}
                       shouldRenderSuggestions={this.shouldRenderSuggestions}
                       alwaysRenderSuggestions={false}
                       onSuggestionSelected={this.onSuggestionSelected} />
          <button className="button button-primary search-button" onClick={this.doSearch} type="submit">{buttonText}</button>
        </form>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  { push, replace, loadSearchSuggestions }
)(SearchFrom);



// WEBPACK FOOTER //
// ./src/components/SearchForm.jsx